import BlockShortcutImages from 'components/BlockShortcutImages';
import ComponentPlaceholder from 'components/ComponentPlaceholder';
import { LayoutContainer } from 'components/Layout';
import Text from 'components/Text';
import type {
	CatalogReference,
	Field,
	SitecoreBlockProps,
} from 'models/sitecore';
import { getEditorMargin } from 'utils/business-logic';
import { filterTruthy } from 'utils/collection';
import { getAsset } from 'utils/helpers';

interface Props extends SitecoreBlockProps {
	fields?: {
		catalogReferences?: CatalogReference[];
		focus?: Field<boolean>;
		heading?: Field<string>;
	};
}

export default function ShortcutImages({ fields, params }: Props) {
	if (!fields) {
		return null;
	}

	const { catalogReferences, focus, heading } = fields;
	// A visual appearance not related to focused elements in the DOM.
	const isFocusVariant = Boolean(focus?.value);

	const items = filterTruthy(
		catalogReferences?.map((ref) => ({
			href: ref.url,
			imgSrc: getAsset('Templated 2:1', ref.fields?.thumbnailImage)?.src,
			text: ref.fields?.title?.value,
		})),
		'href',
		'imgSrc',
		'text',
	);
	// const itemCount = isFocusVariant ? 4 : 6;

	if (items.length === 0) {
		return (
			<ComponentPlaceholder
				className={getEditorMargin(params)}
				componentName="ShortcutImages"
				// description={`Requires at least ${itemCount} functional links with images`}
			/>
		);
	}

	return (
		<LayoutContainer
			id={params?.anchor}
			outerClassName={getEditorMargin(params)}
		>
			<Text as={params?.heading || 'h2'} field={heading} className="mb-6" />
			<BlockShortcutImages
				items={items}
				size={isFocusVariant ? 'large' : 'regular'}
			/>
		</LayoutContainer>
	);
}
ShortcutImages.displayName = 'ShortcutImages';
